/**
 * 重要なお知らせの点滅効果
 */
export const initNoticeNews = (): void => {
    if(document.querySelector('.p-ntc_news')) {
        const elms = document.querySelectorAll<HTMLElement>('.j-blink')
        if(!elms.length) return
        elms.forEach((elm) => {
            elm.classList.add('is-blinking')
        })
    }
}
